import { StrictMode, type ComponentType, type ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { AuthProvider } from './shared/hooks/useAuth';
import { CartProvider } from './shared/hooks/useCart';

/**
 * The single provider tree used by the client (BrowserRouter), the route prerender (StaticRouter)
 * and hydration tests, so the server output and the first client render cannot drift apart.
 */
export default function AppTree({ Router }: { Router: ComponentType<{ children: ReactNode }> }): JSX.Element {
  return (
    <StrictMode>
      <HelmetProvider>
        <Router>
          <AuthProvider>
            <CartProvider>
              <App />
            </CartProvider>
          </AuthProvider>
        </Router>
      </HelmetProvider>
    </StrictMode>
  );
}
